import React from "react";
import { Accordion } from "react-bootstrap";
import Resources from "../../../../types/Resources";
import InformationAlert from "../../../Common/InformationAlert";
import { permitPageUrl } from "../../../../common/permitUtils";
import { PermitType } from "../../../../common/enums";
import SignatureDisplay from "../../../Signatures/SignatureDisplay";
import BaseUserInfo from "../../../../types/BaseUserInfo";
import { SignatureManager } from "../../../../hooks/useSignature";
import SignatureModal from "../../../Signatures/SignatureModal";

type FinishPermitAccordionProps = {
    resources: Resources;
    showViewFinishPermitLink: boolean | undefined;
    lastInSeriesDocumentId: string;
    permitType: PermitType;
    isFinishedPermitProviderSignatureManager: SignatureManager;
    isFinishedPermitSeekerSignatureManager: SignatureManager;
    baseUserInfo: BaseUserInfo;
};

function FinishPermitAccordion({
    resources,
    showViewFinishPermitLink,
    lastInSeriesDocumentId,
    permitType,
    isFinishedPermitProviderSignatureManager,
    isFinishedPermitSeekerSignatureManager,
    baseUserInfo
}: FinishPermitAccordionProps) {
    return (
        <>
            <Accordion>
                <Accordion.Item eventKey="FinishPermit">
                    <Accordion.Header>{resources.get("FinishPermit")}</Accordion.Header>
                    <Accordion.Body>
                        {showViewFinishPermitLink ? (
                            <InformationAlert>
                                <span className="me-1">{resources.get("FinishPermitLinkInfo1")}</span>
                                <a href={permitPageUrl({ permitType, documentReferenceId: lastInSeriesDocumentId })}>
                                    <span>{resources.get("FinishPermitLinkInfo2")}</span>
                                </a>
                            </InformationAlert>
                        ) : null}

                        <div>{resources.get("FinishPermitInfo")}</div>
                        <div className="d-flex mt-3">
                        <SignatureDisplay
                                signatureManager={isFinishedPermitSeekerSignatureManager}
                                resources={resources}
                                signatureLabel={resources.get("PermitSeekerSignatureLabel")}
                                containerClassName="me-5"
                                showDate
                            />
                            <SignatureDisplay
                                signatureManager={isFinishedPermitProviderSignatureManager}
                                resources={resources}
                                signatureLabel={resources.get("PermitProviderSignatureLabel")}
                                showDate
                            />

                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <SignatureModal
                SignatureManager={isFinishedPermitProviderSignatureManager}
                resources={resources}
                ref={isFinishedPermitProviderSignatureManager.signaturePadRef}
            />
            <SignatureModal
                SignatureManager={isFinishedPermitSeekerSignatureManager}
                resources={resources}
                ref={isFinishedPermitSeekerSignatureManager.signaturePadRef}
            />
        </>
    );
}

export default FinishPermitAccordion;
